export enum EndPointTypes {
  undefined = 0,
  sink = 1,
  module = 2
}
